export default __webpack_public_path__ + "static/media/pic14.16dc5544.jpg";